

// PDP video swiper
var swiper = new Swiper(".video-action_slider", {
  autoplay: false,
  spaceBetween: 16,
  slidesPerView: 2,
  navigation: false,
  pagination: {
    clickable: true,
    el: ".ct-product_video-action .video_action-pagination",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1025: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
  },
});
var swiper = new Swiper(".ct_product-pair-swiper", {
  autoplay: false,
  spaceBetween: 20,
  slidesPerView: 2,
  navigation: false,
  pagination: {
    clickable: true,
    el: ".ct_product-pair-with .video_action-pagination",
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    1025: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
  },
});

// PDP video playing
document.addEventListener("DOMContentLoaded", function () {
  const videoWrappers = document.querySelectorAll(".video-action_media_wrp");
  videoWrappers.forEach(wrapper => {
    const video = wrapper.querySelector("video");
    const playBtn = wrapper.querySelector(".video-play_btn");
    if (!video || !playBtn) return;
    playBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      document.querySelectorAll(".video-action_media_wrp video").forEach(v => {
        if (v !== video) {
          v.pause();
          v.currentTime = 0;
          v.closest(".video-action_media_wrp")
           .classList.remove("video-playing");
        }
      });
      if (video.paused) {
        video.play();
        wrapper.classList.add("video-playing");
      } else {
        video.pause();
        wrapper.classList.remove("video-playing");
      }
    });
    wrapper.addEventListener("click", function () {
      if (!video.paused) {
        video.pause();
        video.currentTime = 0;
        wrapper.classList.remove("video-playing");
      }
    });

  });
});